import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchProjects } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

import { prepareProjectApiFilters } from '../filters/project-filters-helpers';
import {
  appliedProjectsFiltersState,
  projectsSortState,
} from '../project.state';
import { useAtomValue } from 'jotai';

export const useProjects = () => {
  const { hasRequiredPermission } = useUserPermissions();

  const appliedFilters = useAtomValue(appliedProjectsFiltersState);

  const sortState = useAtomValue(projectsSortState);
  const sort = sortState?.sort;
  const direction = sortState?.direction;

  const filters = prepareProjectApiFilters(appliedFilters);

  return useInfiniteQuery({
    queryKey: [QueryKey.Projects, sort, direction, filters],
    queryFn: ({ pageParam = 1 }) => {
      const params = {
        sort,
        direction,
        page: pageParam,
        items: 20,
        ...filters,
      };
      return fetchProjects(params);
    },
    initialPageParam: 1,
    enabled: hasRequiredPermission(PERMISSION.VIEW_PROJECT_LIST),
    staleTime: 1000 * 10 * 5,
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.length ? allPages.length + 1 : undefined;
      return nextPage;
    },
  });
};
